module.exports = __webpack_public_path__ + "static/media/Group_2203.c2658f67.png";